import { useMe } from "@/lib/graphql/me"
import type { MeFeatureFlag } from "@/lib/graphql/me"

type UseFeatureFlagReturn = {
	refetch: () => void
	featureFlag?: MeFeatureFlag
}

export const useFeatureFlag = (): UseFeatureFlagReturn => {
	const { refetch, salon } = useMe()
	return {
		refetch,
		featureFlag: salon?.featureFlag,
	}
}
